// LandingPage.js
import React from 'react';
import { Box } from '@mui/material';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import Footer from './Footer';

const MainInicio = () => (
  <Box>
    <Box mt={10}>
      <HeroSection />
      <FeaturesSection />
      <Footer />
    </Box>
  </Box>
);

export default MainInicio;
